import React from 'react';
import BottomNav from '../components/BottomNav';

const InsuranceWealthProtection = () => {
  return (
    <div className="page-container">
      <div className="page-wrapper">
        <h1 className="page-title">Insurance & Wealth Protection</h1>
        <div className="underline"></div>
        <p className="page-subtitle">Comprehensive Coverage Solutions</p>
        
        <div className="card">
          <p>
            Premium insurance solutions tailored to high-net-worth individuals. 
            Protect your assets, lifestyle, and legacy with comprehensive coverage.
          </p>
          
          <div className="service-features">
            <div className="feature-item">
              <h3>High-Value Insurance</h3>
              <p>Specialized coverage for luxury assets and properties</p>
            </div>
            <div className="feature-item">
              <h3>Life & Health</h3>
              <p>Premium health and life insurance programs</p>
            </div>
            <div className="feature-item">
              <h3>Liability Protection</h3>
              <p>Comprehensive liability and legal protection</p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default InsuranceWealthProtection;
